var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.395,
    height: 27,
    viewBox: "0 0 23.395 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-bag-4248850",
    transform: "translate(-70.87 -105.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(67 104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9484",
    "data-name": "Path 9484",
    d: "M27.261,23.686,25.629,8.02A2.694,2.694,0,0,0,22.944,5.6H19.975a4.5,4.5,0,0,0-8.817,0H8.189A2.694,2.694,0,0,0,5.5,8.02L3.872,23.686a.76.76,0,0,0,0,.1A5.225,5.225,0,0,0,9.087,29H22.046a5.225,5.225,0,0,0,5.219-5.219.76.76,0,0,0,0-.094ZM15.566,3.8a2.7,2.7,0,0,1,2.546,1.8H13.021a2.7,2.7,0,0,1,2.546-1.8Zm6.48,23.4H9.087a3.423,3.423,0,0,1-3.419-3.375L7.294,8.207A.9.9,0,0,1,8.189,7.4H22.942a.9.9,0,0,1,.895.807l1.627,15.621A3.423,3.423,0,0,1,22.046,27.2Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9485",
    "data-name": "Path 9485",
    d: "M19.733,11.333a.934.934,0,0,0-.933.934,2.8,2.8,0,0,1-5.6,0,.934.934,0,1,0-1.867,0,4.667,4.667,0,0,0,9.334,0A.934.934,0,0,0,19.733,11.333Z",
    transform: "translate(-0.434 -0.416)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu7);
export default __webpack_public_path__ + "static/media/menu-7.0fadcfeb3daa43ab7b79581ebdc932b8.svg";
export { ForwardRef as ReactComponent };